import React, { useEffect, useState } from "react";
import banner from "../../../../template/images/glossary-finance-banner.png";
import axiosInstance from "../../../../util/axiosInstance";
import { Apiurl } from "../../../../util/apiurl";
import Loader from "../../../layout/lodaer";

function GlossaryMain() {
  const [glossaryData, setGlossaryData] = useState([]);
  const [selectedLetter, setSelectedLetter] = useState("A");
  const [isAccordionOpen, setIsAccordionOpen] = useState(null);
  const [noDataMessage, setNoDataMessage] = useState("");
  const [noDataMessageAlpha, setNoDataMessageAlpha] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

 
  useEffect(() => {
    if (!searchTerm) {
      fetchData(selectedLetter);
    }
  }, [selectedLetter]);

  const fetchData = async (letter) => {
    try {
      const response = await axiosInstance.get(
        `${Apiurl.glossarySearch}?startsWith=${letter}&category=finance`
      );
      if (response.data.glossaryDTOList.length === 0) {
        setNoDataMessageAlpha(
          `No glossary terms found starting with '${letter}'`
        );
        setGlossaryData([]);
      } else {
        setNoDataMessageAlpha("");
        setGlossaryData(response.data.glossaryDTOList);
      }
    } catch (error) {
      console.error("Error fetching glossary data: ", error);
      setNoDataMessageAlpha(`No data found for '${letter}'`);
      setGlossaryData([]);
    }
  };

  const handleLetterClick = (letter) => {
    setSelectedLetter(letter);
    setGlossaryData([]);
    setNoDataMessage("");
    setNoDataMessageAlpha("");
    setSearchTerm("");
    setSearchResults(null);
    setIsAccordionOpen(null);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setSelectedLetter(""); // Clear the selected letter when searching
  };

  const handleSearchClick = async () => {
    if (searchTerm.trim() === "") return;

    try {
      const response = await axiosInstance.get(
        `${Apiurl.glossarySearch}?keyword=${searchTerm}&category=finance`
      );
      if (response.data.glossaryDTOList.length === 0) {
        setNoDataMessage(`No glossary terms found for '${searchTerm}'`);
        setSearchResults(null);
      } else {
        setNoDataMessage("");
        setSearchResults(response.data.glossaryDTOList);
      }
    } catch (error) {
      console.error("Error fetching glossary data: ", error);
      setNoDataMessage(`No data found for '${searchTerm}'`);
      setSearchResults(null);
    }
  };

  const toggleAccordion = (index) => {
    setIsAccordionOpen(isAccordionOpen === index ? null : index);
  };

  return (
    <>
    {!loading ? (
    <>
      <div className="glossary-main">
        <div className="container-fluid">
          <img src={banner} alt="" className="main-banr-img" />
        </div>
        <div className="container">
          <div className="glossary-search">
            <input
              type="text"
              className="search-input"
              id="search"
              name="search"
              value={searchTerm}
              onChange={handleSearchChange}
              placeholder="Search any word or phrase"
            />
            <button className="search-btn" onClick={handleSearchClick}>
              Search
            </button>
          </div>
         
          {searchResults && (
            <div className="search-alpahbet-section">
              {searchResults ? (
                <>
                  {searchResults.map((term, index) => (
                    <div className="search-col" key={index}>
                      <span className="terms-by">
                      </span>
                      <span className="searched-word">{term.keyword}</span>
                      <p>{term.description}</p>
                    </div>
                  ))}
                </>
              ) : (
                <>
                  <span className="terms-by">
                    Financial Terms By: {selectedLetter}
                  </span>
                  {noDataMessage && (
                    <p className="no-data-message">{noDataMessage}</p>
                  )}
                </>
              )}
            </div>
          )} 
          {noDataMessage && (
            <div className="search-alpahbet-section">
              <span className="terms-by">
                {/* Financial Terms By: {selectedLetter} */}
              </span>
              <p className="no-data-message">{noDataMessage}</p>
            </div>
          )}

          <div className="discover-alphabet-section">
            <h4>Discover Finance Terms Alphabetically</h4>
            <div className="alphabet-btns">
              {"ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").map((letter) => (
                <button
                  key={letter}
                  className={selectedLetter === letter ? "active" : ""}
                  onClick={() => handleLetterClick(letter)}
                >
                  {letter}
                </button>
              ))}
            </div>

            {glossaryData && (
              <>
              {selectedLetter && (
              <div className="alphabet-box">
                <span className="searched-alpahbet">{selectedLetter}</span>
                <div className="alphabet-terms">
                  <div className="row">
                    {noDataMessageAlpha ? (
                      <div className="col-12">
                        <p className="no-data-message">{noDataMessageAlpha}</p>
                      </div>
                    ) : (
                      glossaryData.map((term, index) => (
                        <div className="col-12 col-md-4" key={index}>
                          <div className="alphabet-row">
                            <div
                              className="alpha-text-row"
                              onClick={() => toggleAccordion(index)}
                            >
                              <span
                                className={
                                  isAccordionOpen === index
                                    ? "open-txt"
                                    : "alphabet-text"
                                }
                              >
                                {term.keyword}
                              </span>
                              <span>
                                <i
                                  className={`fa fa-chevron-right ${
                                    isAccordionOpen === index ? "rotate" : ""
                                  }`}
                                ></i>
                              </span>
                            </div>
                            {isAccordionOpen === index && (
                              <div className="alphabet-desc">
                                {term.description}
                              </div>
                            )}
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </div>
                  )
                  }
                  </>
            )}
          </div>
        </div>
      </div>
    </>
  ) : (
    <Loader />
  )}
</>
  );
}

export default GlossaryMain;
